import React, { useRef, useState } from "react";
import { Modal, Tooltip } from "@mui/material";
import { apiGetRequestHistory } from "../../services/api.service";

const types = {
  full_name: "Thay đổi họ và tên", phone_number: "Cập nhật số điện thoại",
  bank: "Thay đổi thông tin ngân hàng", reset_pass: "Cấp lại mật khẩu đăng nhập",
  email: "Thay đổi email", birthday: "Thay đổi ngày sinh",
  confirm_account: "Xác minh tài khoản",
};
const statuses = { no_process: "Đang chờ xử lý", approved: "Đã xử lý thành công", removed: "Đã từ chối" };

// Convert supported note markup into React elements without copying HTML attributes.
function renderNote(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const allowed = ["p", "div", "span", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "pre", "code", "a"];
  const blocked = ["script", "style", "iframe", "object", "embed", "svg", "math", "form", "input", "button", "select", "textarea"];
  const render = (node, key) => {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1) return null;
    const tag = node.tagName.toLowerCase();
    if (blocked.includes(tag)) return null;
    const children = Array.from(node.childNodes).map(render);
    if (!allowed.includes(tag)) return children;
    const props = { key };
    if (tag === "a") {
      const href = node.getAttribute("href") || "";
      if (/^(https?:\/\/|mailto:)/i.test(href)) {
        props.href = href;
        props.target = "_blank";
        props.rel = "noopener noreferrer";
      }
    }
    return React.createElement(tag, props, tag === "br" ? undefined : children);
  };
  return Array.from(doc.body.childNodes).map(render);
}

export default function RequestHistory({ account, requests, lastBank = "" }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const busy = useRef(false);

  const lookup = async (event) => {
    event.preventDefault();
    if (busy.current) return;
    setError("");
    // Empty input falls back to the last_bank digits from the entry link.
    const value = code || lastBank;
    if (!/^(?:[a-z0-9]{8}|\d{4})$/i.test(value)) {
      setError("Vui lòng nhập mã yêu cầu 8 ký tự hoặc 4 số cuối tài khoản ngân hàng.");
      return;
    }
    busy.current = true;
    setLoading(true);
    try {
      const result = await apiGetRequestHistory(account, value.toLowerCase());
      if (result?.code === 200 && result.data?.result && Array.isArray(result.data.requests)) setResults(result.data.requests);
      else setError(result?.message || "Không thể tra cứu. Vui lòng thử lại.");
    } finally {
      busy.current = false;
      setLoading(false);
    }
  };

  return <details className="request-history" open>
    <summary>
      KIỂM TRA LỊCH SỬ YÊU CẦU
      <Tooltip title="Hiển thị tóm tắt 2 yêu cầu gần nhất. Nhập mã yêu cầu để xem một kết quả hoặc 4 số cuối tài khoản ngân hàng để xem danh sách kết quả trong 7 ngày." arrow enterTouchDelay={0}>
        <button type="button" className="request-history-help" aria-label="Hướng dẫn tra cứu lịch sử" onClick={(event) => event.preventDefault()}>!</button>
      </Tooltip>
    </summary>
    {!requests.length && <p>Chưa có yêu cầu trong 7 ngày gần nhất.</p>}
    {requests.slice(0, 2).map((item, index) => <div className="request-history-item" key={index}>
      <strong>{types[item.update_type] || item.update_type}</strong>
      <span>{item.id_verify ? `xxxxxx${item.id_verify.slice(-2)}` : "Chưa có mã tra cứu"}</span>
      <span className={`request-history-status ${item.status}`}>{statuses[item.status] || item.status}</span>
    </div>)}
    <form className="request-history-form" onSubmit={lookup}>
      <input aria-label="Mã yêu cầu hoặc 4 số cuối tài khoản ngân hàng" placeholder={lastBank ? "Nhấn Kiểm tra hoặc nhập mã yêu cầu" : "Mã yêu cầu hoặc 4 số cuối STK"} maxLength={8} value={code} autoCapitalize="none" autoComplete="off" onChange={(event) => { setCode(event.target.value.replace(/[^a-z0-9]/gi, "")); setError(""); }} />
      <button type="submit" disabled={loading}>{loading ? "Đang kiểm tra..." : "Kiểm tra"}</button>
    </form>
    {error && <p className="request-history-error" role="alert">{error}</p>}
    <Modal open={results !== null} onClose={() => setResults(null)}>
      <div className="request-history-modal" role="dialog" aria-modal="true" aria-labelledby="history-title" tabIndex={-1}>
        <button type="button" className="request-history-close" aria-label="Đóng kết quả" onClick={() => setResults(null)}>×</button>
        <h3 id="history-title">Kết quả tra cứu yêu cầu</h3>
        {results?.length === 0 && <p>Chưa có yêu cầu trong 7 ngày gần nhất.</p>}
        {results?.map((request, index) => <div className="request-history-result" key={`${request.id_verify}-${request.createdAt}-${index}`}>
          {request.id_verify && <p><strong>Mã yêu cầu:</strong> {request.id_verify}</p>}
          <p><strong>Loại yêu cầu:</strong> {types[request.update_type] || request.update_type}</p>
          <p><strong>Trạng thái:</strong> <span className={`request-history-status ${request.status}`}>{statuses[request.status] || request.status}</span></p>
          {request.can_view_result === false ? <p className="request-history-error">{request.message || "Vui lòng dùng thiết bị lúc thực hiện yêu cầu này để kiểm tra kết quả xử lý."}</p> : <>
            {request.data_update?.content && <p><strong>Nội dung:</strong> {request.data_update.content}</p>}
            {request.note && <div className="request-history-note"><strong>Ghi chú/Kết quả:</strong>{renderNote(request.note)}</div>}
            {request.new_password && !request.note?.includes(request.new_password) && <p><strong>Mật khẩu mới:</strong> {request.new_password}</p>}
          </>}
          {request.createdAt && <p><strong>Ngày gửi:</strong> {new Date(request.createdAt).toLocaleString("vi-VN")}</p>}
        </div>)}
      </div>
    </Modal>
  </details>;
}
